<template>
    <main>
		<HeaderTab 
            :title="$t('global.notes')"
        />

		<div id="content">
			<div class="container-fluid">
                <div class="row">
					<div class="col-12">
						<NotesList :is_client_area="true" />
					</div>
				</div>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	export default {
		name: "noteListe",
		components: {
            HeaderTab: () => import('GroomyRoot/components/HeaderTab'),
			NotesList: () => import('GroomyRoot/components/Notes/List')
		}
	}
</script>
